<template>
  <section>
    <div class="friendLink">
      <div class="friendLinkContent">
        <div class="friendLinkTitle">友情链接</div>
        <ul class="friendLinkDetail clean">
          <li v-for='item in linkList' :key='item.site_url'>
            <span @click='gotoLinkUrl(item.site_url)'>{{item.site_name}}</span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
   import { Api } from '../service/api'
  export default{
    name: 'FriendlyLink',
    data() {
      return {
        linkList: []
      }
    },
    methods: {
      gotoLinkUrl(url) {
          window.open(url)
      },
      getSiteInfo() {
        let params = {}
          Api.getSiteInfo(params).then((res) => {
            if(res.data.code == 1){
              if(res.data.data && res.data.data.link_list){
                this.linkList = res.data.data.link_list
              }
            }
          })
        }
    },
    mounted() {
      this.getSiteInfo()
    }
  }
</script>
<style lang='scss' scoped>
  section{
    margin-top: 20px;
    background: #21232f;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(112, 112, 112, 0.2);
    .friendLink {
      padding: 0 2.5rem 30px;
      height: 106px;
      opacity: 1;
      padding-top: 14px;
      .friendLinkTitle {
        width: 89px;
        height: 29px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 24px;
        color: #fff;
        text-align: left;
        margin-bottom: 6px;
      }
      .friendLinkDetail{
        height: 30px;
        line-height: 30px;
        text-align: left;
        li{
          display: inline-block;
          text-align: center;
          line-height: 24px;
          width: 10%;
          span{
            color: #aaa;
            cursor: pointer;
            &:hover{
              color: #fc5f35;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FriendlyLink.vue